import { Box } from '@osmosis/react-ui/components/Box';
import { Icon } from '@osmosis/react-ui/components/Icon';
import { IconButton } from '@osmosis/react-ui/components/IconButton';
import { useState } from 'react';
import PopupMenu, { PopupMenuItem } from '../../PopupMenu';
import { QuizSettingsPopupItems } from './QuizSettingsPopupItem';
import { useQuizContext } from '../../../context/QuizContext';
import FeedbackForm from '../../learn/FeedbackForm';
import { useCMEContext } from '../../../context/CMEContext';
import { useQuizItems } from '../../../context/QuizItemsProvider';
import { useIntl } from 'react-intl';
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons/faEllipsisV';

type Props = {
  items?: PopupMenuItem[];
  heading?: string;
};

/**
 * Component with flashcard options.
 */
export const QuizSettingsPopup = (props: Props) => {
  const { heading, items: _items = [] } = props;
  const { items: sharedItems, feedbackModal } = useQuizItems();
  const intl = useIntl();
  const { currentItem } = useQuizContext();
  const { concept = '' } = useCMEContext();

  const [isOpen, setOpen] = useState(false);
  const itemsQuizSettingsPopup = [..._items, ...sharedItems];

  return (
    <Box>
      <FeedbackForm
        videoTitle={concept}
        nodeID={currentItem?.nodeID || 0}
        subjectText={intl.formatMessage(
          {
            id: 'learn.header.feedback_subject_question',
            defaultMessage: `Subject: Feedback on Question Item {nodeID}`,
          },
          {
            nodeID: currentItem?.nodeID || 0,
          },
        )}
        {...feedbackModal}
      />

      <PopupMenu
        heading={heading}
        keyExtractor={(item) => item.id}
        isVisible={isOpen}
        hide={() => setOpen(false)}
        renderItem={(item) => {
          return <QuizSettingsPopupItems item={item} setOpen={setOpen} />;
        }}
        centerHeading={true}
        items={itemsQuizSettingsPopup}
        containerClasses="m-w-[300px]"
      >
        <IconButton
          data-testid="quiz-settings-popup-btn"
          icon={<Icon icon={faEllipsisV} />}
          onClick={() => setOpen(!isOpen)}
          variant="transparent"
          fontSize={16}
          color="gray50"
        />
      </PopupMenu>
    </Box>
  );
};
